module.exports = __webpack_public_path__ + "static/media/badge-googleplay.c7551a6e.svg";